import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";

export default function ResizeModal({ shapeImage, setShapeImage, open, onClose }) {
    const [visible, setVisible] = useState(false);
    const [folderOpen, setFolderOpen] = useState(false);

    useEffect(() => {
        if (open) setVisible(true);
        else setTimeout(() => setVisible(false), 200);
    }, [open]);

    if (!open && !visible) return null;

   const shapes = [
        "Boom Display (16:9)",
        "Facebook Post (4:5)",
        "Instagram Post (1:1)",
        "Landscape (16:9)",
        "Portrait (9:16)",
        "Square (1:1)",
        "TikTok/Stories (9:16)",
        "YouTube Thumbnail (16:9)"
    ];

    // MOBILE OPTIMIZATION
    const isMobile = window.innerWidth < 768;

    const styles = {
        backdrop: {
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: isMobile ? "flex-start" : "center",
            justifyContent: "center",
            paddingTop: isMobile ? 40 : 0,
            zIndex: 1000,
        },
        modal: {
            width: isMobile ? "95%" : 520,
            maxHeight: isMobile ? "90vh" : "auto",
            overflowY: "auto",
            padding: isMobile ? "20px 16px" : 28,
            borderRadius: isMobile ? 16 : 20,
            background: "linear-gradient(180deg, #0F1419, #0B0F14)",
            border: "2px solid #2B3440",
            boxSizing: "border-box",
            transform: "translateY(20px) scale(0.96)",
            opacity: 0,
            transition: "all 0.25s ease",
            display: "flex",
            flexDirection: "column",
        },
        modalIn: { transform: "translateY(0) scale(1)", opacity: 1 },
        modalOut: { transform: "translateY(20px) scale(0.96)", opacity: 0 },
        title: { fontSize: 24, fontWeight: 700, marginBottom: 10, color: "#fff", textAlign: "left" },
        subtitle: { fontSize: 16, color: "#9CA3AF", marginBottom: 26, textAlign: "left" },
        label: { fontSize: 15, fontWeight: 600, marginBottom: 8, display: "block", color: "#fff", textAlign: "left" },
        fieldWrapper: { position: "relative", width: "100%", marginBottom: 18 },
        dropdown: {
            width: "100%",
            borderRadius: 14,
            border: "2px solid #2B3440",
            padding: "14px 16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            background: "#0F1419",
            color: "#fff",
            boxSizing: "border-box",
        },
        dropdownMenu: {
            position: "absolute",
            top: 60,
            left: 0,
            width: "100%",
            background: "#0F1419",
            borderRadius: 14,
            border: "2px solid #2B3440",
            maxHeight: isMobile ? 200 : 220,
            overflowY: "auto",
            zIndex: 20,
        },
        dropdownItem: {
            padding: "14px 16px",
            fontSize: 15,
            cursor: "pointer",
            color: "#E5E7EB",
            borderBottom: "1px solid #1F2937",
        },
        dropdownItemActive: {
            background: "linear-gradient(90deg, #EE4037, #F7941D)",
            color: "#fff",
            fontWeight: 600,
        },
        footer: {
            display: "flex",
            gap: 12,
            flexDirection: isMobile ? "column" : "row",
            marginTop: 24,
        },
        cancelBtn: {
            width: "100%",
            height: isMobile ? 60 : 56,
            borderRadius: 16,
            border: "none",
            background: "#374151",
            color: "#fff",
            fontSize: 18,
            fontWeight: 600,
            cursor: "pointer",
        },
        saveBtn: {
            width: "100%",
            height: isMobile ? 60 : 56,
            borderRadius: 16,
            border: "none",
            background: "linear-gradient(135deg, #EE4037, #F7941D)",
            color: "#fff",
            fontSize: 18,
            fontWeight: 700,
            cursor: "pointer",
        },
    };

    return (
        <div style={styles.backdrop} onClick={onClose}>
            <div
                style={{
                    ...styles.modal,
                    ...(open ? styles.modalIn : styles.modalOut),
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <h2 style={styles.title}>Resize Image</h2>
                <p style={styles.subtitle}>
                    Choose a new size for your image. This will create a new version with the same content.
                </p>

                <label style={styles.label}>Select New Size</label>
                <div style={styles.fieldWrapper}>
                    <div style={styles.dropdown} onClick={() => setFolderOpen(!folderOpen)}>
                        <span style={{ color: shapeImage ? "#fff" : "#9CA3AF" }}>
                            {shapeImage || "Choose a shape..."}
                        </span>
                        <ChevronDown size={18} color="#F7941D" />
                    </div>

                    {folderOpen && (
                        <div style={styles.dropdownMenu}>
                            {shapes.map((f) => (
                                <div
                                    key={f}
                                    onClick={() => { setShapeImage(f); setFolderOpen(false); }}
                                    style={{
                                        ...styles.dropdownItem,
                                        ...(shapeImage === f ? styles.dropdownItemActive : {}),
                                    }}
                                >
                                    {f}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div style={styles.footer}>
                    <button style={styles.cancelBtn} onClick={onClose}>Cancel</button>
                    <button style={styles.saveBtn} onClick={onClose}>Resize Image</button>
                </div>
            </div>
        </div>
    );
}
